"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Display = void 0;
var Display;
(function (Display) {
    Display["None"] = "u-none";
    Display["Block"] = "u-block";
    Display["InlineBlock"] = "u-inline-block";
    Display["Inline"] = "u-inline";
    Display["Table"] = "u-table";
    Display["TableRow"] = "u-table-row";
    Display["TableCell"] = "u-table-cell";
    Display["Flex"] = "u-flex";
    Display["InlineFlex"] = "u-inline-flex";
    Display["Grid"] = "u-grid";
    Display["GridInline"] = "u-grid-inline";
})(Display = exports.Display || (exports.Display = {}));
//# sourceMappingURL=Display.js.map